<template>
  <main>
   <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
   <section-article
      :article="article"
      v-if="article.title"
      isTopSection="true"
      id="scrollToOnLoad">
   </section-article>
   <section class="section--technical">
    <b-container>
      <b-row>
        <b-col>
          <div v-for="(question, index) in questions" :key="index">
            <h5 v-html="question.title"></h5>
            <p class="technical__text" v-html="question.question"></p>
          </div>
        </b-col>
      </b-row>
     </b-container>
    </section>
   <section-support></section-support>
  </main>
</template>

<script>
import support from '@/api/v1/technicalSupport';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import Article from '@/components/Article';

export default {
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      questions: [],
      article: {},
    };
  },
  components: {
    'section-hero': Hero,
    'section-article': Article,
    'section-support': Support,
  },
  methods: {
    getContent() {
      const succ = (response) => {
        this.article = response.data.technical_support;
      };
      support.index(succ);
    },
    getQuestions() {
      const succ = (response) => {
        this.questions = response.data.questions_technical_support;
      };
      support.question(succ);
    },
  },
  created() {
    this.getContent();
    this.getQuestions();
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';

.section {
  &--technical {
    padding-bottom: 40px;
    @include media('<lg') {
      background-color: $color--gray-4;
      padding: 40px 0;
    }
  }
}
.technical {
  &__text {
    font-size: 16px;
    line-height: 24px;
    padding: 12px 0 40px;
    margin: 0;
    @include media('<lg') {
      padding: 15px 0 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StaticPages/TechnicalSupport.vue